module.exports = __webpack_public_path__ + "static/media/Daniel_Zacarias.05a209b5.jpg";